import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, BiDashboard, inject, NothingHere, PowerBIStore, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppStore } from '../Core/AppStore';

export interface IDashboardViewParams {
    dashboardId: string;
}
export interface IDashboardViewProps extends RouteComponentProps<IDashboardViewParams> {}

@autoinject
@observer
export class DashboardView extends React.Component<IDashboardViewProps> {
    @action
    public async componentDidMount() {
        this.loading = true;

        try {
            await this.powerBIStore.loadPowerBiDashboardAsync(this.props.match.params.dashboardId, {
                params: { provision: false },
            });
        } catch (e: any) {
            this.appStore.notificationHandle.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container-fluid p-0 h-100">
                <Title>{this.dashboard?.dashboard?.displayName ?? this.props.match.params.dashboardId}</Title>

                <BiDashboard
                    type="dashboard"
                    reportOrDashboardId={this.props.match.params.dashboardId}
                    filterPaneEnabled={true}
                    navContentPaneEnabled={true}
                    darkTheme={this.appStore.storage.theme == 'dark-theme'}
                    history={this.props.history}
                    location={this.props.location}
                />
            </div>
        );
    }

    @computed
    private get dashboard() {
        return this.powerBIStore.dashboards.get(this.props.match.params.dashboardId);
    }

    @observable
    private loading = false;
    @inject
    private appStore!: AppStore;
    @inject
    private powerBIStore!: PowerBIStore;
}
